import React, {Component, Fragment} from 'react';
import {
	Button,
	Card,
	CardBody,
	Col,
	Collapse,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Nav,
	Navbar,
	NavbarBrand,
	NavbarToggler,
	Row,
	UncontrolledDropdown
} from 'reactstrap';

class AdminForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			value:  ''
		};

		this.toggle = this.toggle.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	toggle() {
		this.setState({
			isOpen: !this.state.isOpen
		});
	}

	handleChange(event) {
		this.setState({value: event.target.value});
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.adminWrite(this.props.subsection, this.state.value);
	}

	render() {
		const adminSubsections = [
			'EMPLOYEES',
			'EXIT_METHODS',
			'INSTALLATION_TYPES',
			'LEADSOURCES',
			'MODELS',
			'ORIENTATIONS',
			'SALESPERSONS',
			'STATES',
			'TIMEZONES',
			'TS_ADMIN_VERSIONS',
			'UPDATING_TYPES',
			'WARRANTY_TYPES',
		];

		let navItems = adminSubsections.map((sub, i) => {
			return (
				<Fragment key={`admin-sub-${i}`}>
					<DropdownItem
						onClick={() => {
							this.props.changeSubsection(sub);
						}}
					>
						{sub.split('_').join(' ')}
					</DropdownItem>
					<DropdownItem divider />
				</Fragment>
			);
		});

		let tableComponent = this.props.makeAdminTable(this.props.subsection);

		let btn = (
			<Button onClick={this.props.adminUpdate} className="adminSave">
						  Save Edits
			</Button>
		);

		let entryAdder = (
			<form onSubmit={this.handleSubmit}>
				<label>
								Add entry to {this.props.subsection.split('_').join(' ')}{' '}
								Dropdown:<br />
					<input
						type="text"
						value={this.state.value}
						onChange={this.handleChange}
					/>
				</label>
				<input type="submit" value="Submit" />
			</form>
		);

		// TODO center the actual dropdown now:
		return (
			<div>
				<Row>
					<Col xs={12}>
						<header className="full-width2 nav">
							<Navbar color="light" light expand="md">
								<NavbarBrand>
									TS Admin -- Editing:{' '}
									{this.props.subsection.split('_').join(' ')}
								</NavbarBrand>
								<NavbarToggler onClick={this.toggle} />
								<Collapse isOpen={this.state.isOpen} navbar>
									<Nav className="mr-auto" navbar>
										<UncontrolledDropdown nav inNavbar>
											<DropdownToggle nav caret>
												Change Section
											</DropdownToggle>
											<DropdownMenu right>{navItems}</DropdownMenu>
										</UncontrolledDropdown>
									</Nav>
								</Collapse>
							</Navbar>
						</header>
						<br />
						<br />
						<br />
					</Col>
					<Col />
					<Col xs={8}>
						{entryAdder}
					</Col>
					<Col xs={12} className="saveBtnCont">
						{btn}
					</Col>
					<Col xs={12}>{tableComponent}</Col>
				</Row>
			</div>
		);
	}
}

export default AdminForm;



// WEBPACK FOOTER //
// ./src/components/AdminForm.js